var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframeContainer",style:({ height: _vm.iframeHeight + 'px !important' })},[(_vm.camera)?_c('iframe',{staticClass:"demos__iframe w-100",style:({ height: _vm.iframeHeight + 'px !important' }),attrs:{"src":_vm.demoUrl,"frameborder":"0","allowfullscreen":"allowfullscreen"},on:{"load":_vm.onIframeLoaded}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }